var React = require('react');

function PlusIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.02,19.485c0-.315-.135-.45-.45-.45H13.43c-.315,0-.45.135-.45.45v7.6H5.375c-.315,0-.45.135-.45.45v4.14c0,.315.135.45.45.45H12.98v7.605c0,.315.135.45.45.45h4.14c.315,0,.45-.135.45-.45V32.13h7.6c.315,0,.45-.135.45-.45V27.54c0-.315-.135-.45-.45-.45h-7.6Z","transform":"translate(-16.942 4.978) rotate(-45)","fill":"#fff"}));
}

PlusIcon.defaultProps = {"width":"29.911","height":"29.911","viewBox":"0 0 29.911 29.911"};

module.exports = PlusIcon;

PlusIcon.default = PlusIcon;
